import { useMutation } from '@tanstack/react-query';
import { login } from '@/api/auth.api';

/**
 * Credential verification (FR-03/FR-04).
 *
 * This hook deliberately stores nothing and navigates nowhere itself -
 * `LoginPage`'s `onSuccess` does that, since what happens next depends on the
 * outcome's shape. Normally `/auth/login` returns a `LoginChallenge` (no
 * session yet) and the caller transitions to the second-factor step carrying
 * it; the session is then issued by `useVerifyTwoFactor`. While MYN-77 is
 * temporarily disabled (client request, 2026-09-03), it returns the session
 * directly instead (`LoginSessionResult`), and the caller completes the
 * login itself via `completeLoginSession` - see `LoginPage`'s doc comment.
 *
 * Either way, a `LoginChallenge`'s `preAuthToken` must not be written through
 * `lib/auth/session.ts` (`docs/specs/features/identity-access/02-design.md` §11 decision 2).
 */
export function useLogin() {
  return useMutation({ mutationFn: login });
}
